var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangle20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 590,
    viewBox: "0 0 295 590",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0546875 38.953C0.0546875 17.4636 18.5614 0.0429688 41.3905 0.0429688H253.529C276.358 0.0429688 294.865 17.4636 294.865 38.953V550.656C294.865 572.146 276.358 589.566 253.529 589.566H41.3905C18.5614 589.566 0.0546875 572.146 0.0546875 550.656V38.953Z",
    fill: "#10141B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle20);
export default __webpack_public_path__ + "static/media/rectangle-20.b5023c206a7c3af98328c873029e31e2.svg";
export { ForwardRef as ReactComponent };